import * as Sentry from "@sentry/react";

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Routes } from '@generouted/react-router'

Sentry.init({
  dsn: "https://37720a96bb59311215d303835e84fa0c@o4507974300598272.ingest.de.sentry.io/4509142781657168"
});

// createRoot(document.getElementById('root')).render(<Routes />)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
      <Routes />
  </React.StrictMode>
)
